module.exports = __webpack_public_path__ + "img/signout-black.92830f3e.svg";